(function () {
  "use strict";
  if (window.SBJourney) return;

  function isJourneyBot(ua, webdriver) {
    if (webdriver === true) return true;
    ua = ua == null ? "" : String(ua);
    if (/journey-qa-probe/i.test(ua)) return false;
    if (!ua || ua.length < 20) return true;
    return /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|pingdom|uptime|monitor|python-requests|python-urllib|aiohttp|httpx|go-http-client|java\/|okhttp|curl\/|wget\/|libwww|scrapy|phantomjs|selenium|puppeteer|playwright|facebookexternalhit|facebot|twitterbot|linkedinbot|slackbot|discordbot|telegrambot|whatsapp|skypeuripreview|embedly|quora link preview|pinterestbot|semrush|ahrefs|mj12|dotbot|petalbot|bytespider|ccbot|applebot|amazonbot|yandex|baidu|duckduck|bingpreview|adsbot|mediapartners|apis-google|feedfetcher|google-read-aloud|storebot|screaming frog|sitebulb|netcraft|dataforseo|serpstat|zoominfo|buck|nimbostratus|ia_archiver|archive\.org|wayback|censys|shodan|masscan|nmap|zgrab|nuclei/i.test(ua);
  }

  var automation = false;
  try {
    automation = isJourneyBot(
      typeof navigator !== "undefined" ? navigator.userAgent : "",
      typeof navigator !== "undefined" && navigator.webdriver === true
    );
  } catch (e) {}

  var SID_RE = /^[A-Za-z0-9_-]{8,64}$/;
  var MAX_PENDING = 30;
  var FLUSH_MS = 2000;
  var CONSENT_MS = 3000;
  var DEDUPE_MS = 300;
  var NAV_SURFACES = {
    header_menu: 1,
    mega_menu: 1,
    mobile_nav: 1,
    hero: 1,
    category_tile: 1,
    brand_tile: 1,
    footer: 1,
    breadcrumb: 1
  };
  var ANALYTICS_SURFACES = {
    header_navigation: "header_menu",
    desktop_megamenu: "mega_menu",
    mobile_menu: "mobile_nav",
    homepage_categories: "category_tile",
    homepage_brands: "brand_tile",
    footer_navigation: "footer",
    guided_filters: "guided_filters",
    top_filter_strip: "top_strip",
    filter_sidebar: "side_rail",
    mobile_filter_drawer: "filter_drawer",
    active_filter_chips: "active_chips",
    product_main: "pdp_main",
    cart_recommendations: "cross_sell",
    search_results: "search_results",
    homepage_search: "homepage_search",
    header_search: "header_search"
  };
  var CROSS_SELL_SURFACES = {
    "similar-items": "similar_items",
    similar: "similar_items",
    purchase: "fbt",
    catalog: "cross_sell",
    "cross-sell": "cross_sell",
    fbt: "fbt"
  };
  var FEATURE_SOURCE_SURFACES = {
    similar_items: "similar_items",
    search_results: "search_results",
    search_dropdown: "search_dropdown",
    purchase_addons: "purchase_addon",
    cross_sell: "cross_sell",
    fbt: "fbt"
  };
  var FEATURE_SOURCE_CAP = 50;
  var CART_SID_KEY = "sfs_cart_sid";
  var PRODUCT_SOURCES_KEY = "sfs_product_sources";
  var PENDING_ADD_KEY = "sfs_pending_add";
  var PENDING_ADD_CAP = 5;
  var PENDING_ADD_TTL_MS = 10 * 60 * 1000;

  var queue = [];
  var pendingConsent = [];
  var flushTimer = null;
  var consentDropped = false;
  var consentStopped = false;
  var pendingAddConfirmRan = false;
  var trackingListeners = [];
  var webVitalSent = false;
  var vitalLcp = null;
  var vitalInp = null;
  var vitalInpSeen = false;
  var vitalFcp = null;
  var vitalClsBest = 0;
  var vitalClsSeen = false;
  var vitalClsSession = 0;
  var vitalClsWindow = 0;
  var vitalClsLast = 0;
  var vitalLcpEl = "";
  var vitalLcpUrl = "";
  var vitalNav = "";
  var vitalTtfb = null;
  var jsErrorCount = 0;
  var jsErrorSeen = {};
  var pageStart = Date.now();
  var pageHideSent = false;
  var device = window.innerWidth < 768 ? "m" : "d";
  var quoteStarted = false;
  var inputStarted = {};
  var scrollMarks = { 25: 0, 50: 0, 75: 0, 100: 0 };
  var scrollRaf = 0;
  var lastDedupe = { el: null, ev: "", t: 0 };
  var lastNamedDedupe = {};
  var filterClearTimes = new WeakMap();
  var openMenus = {};
  var sampled = null;

  function clip(value, max) {
    var text = value == null ? "" : String(value);
    if (text.length <= max) return text;
    return text.slice(0, max);
  }

  function journeyPageType(path) {
    path = String(path || "");
    if (path === "/" || path === "") return "home";
    if (/\/a\/search\/?$|\/search\/?$/.test(path)) return "search";
    if (path.indexOf("/products/") !== -1) return "product";
    if (/\/cart\/?$/.test(path)) return "cart";
    if (path.indexOf("/collections/") !== -1) return "collection";
    if (/\/account(?:\/|$)/.test(path)) return "account";
    if (/\/blogs?\//.test(path)) return "blog";
    if (path.indexOf("/pages/") !== -1) {
      if (/quote/i.test(path)) return "quote";
      return "page";
    }
    return "other";
  }

  function scrubJourneyLabel(text) {
    var value = String(text || "").replace(/\s+/g, " ").trim();
    if (!value) return "";
    if (/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i.test(value)) return "";
    if (/\d{7,}/.test(value)) return "";
    if (/(?:\d[ -]*){13,19}/.test(value)) return "";
    return value;
  }

  function journeySampled(sid, rate) {
    var n = Number(rate);
    if (!isFinite(n)) n = 100;
    if (n >= 100) return true;
    if (n <= 0) return false;
    var hash = 0;
    var raw = String(sid || "");
    var i;
    for (i = 0; i < raw.length; i++) {
      hash = ((hash << 5) - hash + raw.charCodeAt(i)) | 0;
    }
    return Math.abs(hash) % 100 < n;
  }

  function buildJourneyBatch(sid, events, isBot, dev) {
    var remaining = events ? events.slice() : [];
    var batches = [];
    var usedDev = false;
    var themeId = 0;
    try {
      var rawTheme = window.theme && window.theme.journey && window.theme.journey.themeId;
      var themeNum = Number(rawTheme);
      if (isFinite(themeNum) && themeNum > 0) themeId = Math.round(themeNum);
    } catch (eTheme) {}
    function pack(chunk, includeDev) {
      var payload = { sid: sid || "", v: 1, events: chunk };
      if (themeId) payload.th = themeId;
      if (isBot === true) payload.bot = true;
      if (includeDev && dev) payload.dev = dev;
      return payload;
    }
    while (remaining.length) {
      var take = remaining.length > 20 ? 20 : remaining.length;
      var chunk = remaining.slice(0, take);
      remaining = remaining.slice(take);
      var includeDev = !usedDev;
      var payload = pack(chunk, includeDev);
      while (chunk.length > 1 && JSON.stringify(payload).length > 8192) {
        remaining.unshift(chunk.pop());
        payload = pack(chunk, includeDev);
      }
      if (payload.dev) usedDev = true;
      batches.push(payload);
    }
    return batches;
  }

  function collectJourneyDev() {
    function num(read) {
      try {
        var n = read();
        if (n == null || n === "") return null;
        n = Number(n);
        return isFinite(n) ? n : null;
      } catch (e) {
        return null;
      }
    }
    function flag(read) {
      try {
        var v = read();
        if (v == null) return null;
        return !!v;
      } catch (e) {
        return null;
      }
    }
    function text(read, max) {
      try {
        var v = read();
        if (v == null || v === "") return null;
        v = String(v);
        return v.length > max ? v.slice(0, max) : v;
      } catch (e) {
        return null;
      }
    }
    var dev = {
      sw: num(function () { return screen.width; }),
      sh: num(function () { return screen.height; }),
      vw: num(function () { return window.innerWidth; }),
      vh: num(function () { return window.innerHeight; }),
      dpr: num(function () { return window.devicePixelRatio; }),
      hc: num(function () { return navigator.hardwareConcurrency; }),
      mem: num(function () { return navigator.deviceMemory; }),
      tz: text(function () { return Intl.DateTimeFormat().resolvedOptions().timeZone; }, 60),
      langs: text(function () {
        var list = navigator.languages;
        if (list && list.length) return Array.prototype.join.call(list, ",");
        return navigator.language || "";
      }, 60),
      touch: num(function () { return navigator.maxTouchPoints; }),
      plugins: num(function () { return navigator.plugins.length; }),
      wd: flag(function () { return navigator.webdriver === true; }),
      cookies: flag(function () { return navigator.cookieEnabled; }),
      pdf: flag(function () { return navigator.pdfViewerEnabled; })
    };
    if (JSON.stringify(dev).length > 300) dev.tz = null;
    if (JSON.stringify(dev).length > 300) dev.langs = null;
    return dev;
  }

  function etSessionDay(ms) {
    try {
      if (!etSessionDay.fmt) {
        etSessionDay.fmt = new Intl.DateTimeFormat("en-CA", {
          timeZone: "America/New_York",
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        });
      }
      return etSessionDay.fmt.format(new Date(ms));
    } catch (e) {
      return "";
    }
  }

  function getSearchSessionId() {
    var SESSION_MS = 30 * 60 * 1000;
    var WRITE_GAP = 60 * 1000;
    try {
      try {
        if (typeof window !== "undefined" && typeof window.sbTrackingAllowed === "function" && window.sbTrackingAllowed() === false) {
          try { localStorage.removeItem("sfs_session"); } catch (e0) {}
          try { localStorage.removeItem("sfs_first"); } catch (e0b) {}
          try { sessionStorage.removeItem("sfs_sid"); } catch (e0c) {}
          return "";
        }
      } catch (eDeny) {}
      var now = Date.now();
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem("sfs_session") || ""); } catch (e1) {}
      var id = saved && SID_RE.test(saved.id) ? saved.id : "";
      var stamp = saved ? Number(saved.t || 0) : 0;
      var dayNow = etSessionDay(now);
      var dayThen = stamp ? etSessionDay(stamp) : "";
      var sameDay = !dayNow || !dayThen || dayNow === dayThen;
      var fresh = !!id && stamp > 0 && (now - stamp) < SESSION_MS && sameDay;
      if (!fresh) {
        id = "";
        try {
          if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
            id = String(crypto.randomUUID()).replace(/-/g, "");
          }
        } catch (e2) {}
        if (!SID_RE.test(id)) {
          id = "";
          while (id.length < 32) id += Math.random().toString(36).slice(2);
          id = id.slice(0, 32);
        }
        stamp = 0;
      }
      if (!fresh || (now - stamp) >= WRITE_GAP) {
        try { localStorage.setItem("sfs_session", JSON.stringify({ id: id, t: now })); } catch (e3) {}
      }
      try {
        if (sessionStorage.getItem("sfs_sid") !== id) sessionStorage.setItem("sfs_sid", id);
      } catch (e4) {}
      return id;
    } catch (e) {
      return "";
    }
  }

  function journeyBeaconUrl() {
    try {
      if (window.theme && window.theme.journey && window.theme.journey.beaconUrl) {
        return window.theme.journey.beaconUrl;
      }
      if (window.theme && window.theme.journeyBeaconUrl) return window.theme.journeyBeaconUrl;
    } catch (e) {}
    return "/apps/sb/journey/beacon";
  }

  function journeyEnabled() {
    try {
      if (window.theme && window.theme.journeyDisabled === true) return false;
      if (window.theme && window.theme.journey && window.theme.journey.enabled === false) return false;
    } catch (e) {}
    return true;
  }

  function sampleRate() {
    try {
      if (window.theme && window.theme.journey && window.theme.journey.sampleRate != null) {
        return window.theme.journey.sampleRate;
      }
    } catch (e) {}
    return 100;
  }

  function isSampled() {
    if (sampled != null) return sampled;
    sampled = journeySampled(getSearchSessionId(), sampleRate());
    return sampled;
  }

  function trackingState() {
    try {
      if (typeof document !== "undefined" && document.prerendering) return "deny";
      if (window.theme && window.theme.editor) return "deny";
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return "wait";
      var analyticsOk = false;
      try {
        analyticsOk = cp.analyticsProcessingAllowed() === true;
      } catch (e1) {
        return "deny";
      }
      if (!analyticsOk) return "deny";
      if (typeof cp.saleOfDataAllowed === "function") {
        try {
          if (cp.saleOfDataAllowed() === false) return "deny";
        } catch (e2) {
          return "deny";
        }
      }
      return "allow";
    } catch (e) {
      return "deny";
    }
  }

  function allowed() {
    try {
      return trackingState() === "allow";
    } catch (e) {
      return false;
    }
  }

  function consentReady() {
    try {
      return trackingState() !== "wait";
    } catch (e) {
      return false;
    }
  }

  function currentPath() {
    try {
      var search = location.search || "";
      try {
        if (search && typeof URLSearchParams !== "undefined") {
          var params = new URLSearchParams(search);
          var hidden = ["gclid", "gbraid", "wbraid", "msclkid", "fbclid"];
          var hi;
          var changed = false;
          for (hi = 0; hi < hidden.length; hi++) {
            if (params.has(hidden[hi])) {
              params.delete(hidden[hi]);
              changed = true;
            }
          }
          if (changed) {
            var next = params.toString();
            search = next ? "?" + next : "";
          }
        }
      } catch (e2) {}
      return clip(location.pathname + search, 200);
    } catch (e) {
      return "";
    }
  }

  function currentPage() {
    try {
      return journeyPageType(location.pathname);
    } catch (e) {
      return "other";
    }
  }

  function referrerHost() {
    try {
      if (!document.referrer) return "";
      return clip(new URL(document.referrer).hostname, 100);
    } catch (e) {
      return "";
    }
  }

  function digits(value) {
    return clip(String(value == null ? "" : value).replace(/\D/g, ""), 40);
  }

  function readOptionValue(form, name, index) {
    try {
      var named = form.querySelector ? form.querySelector("[name='" + name + "']") : null;
      if (named && named.value) return String(named.value);
      var checked = form.querySelector ? form.querySelector("[name='" + name + "']:checked") : null;
      if (checked && checked.value) return String(checked.value);
      var options = form.querySelectorAll ? form.querySelectorAll("[data-option-index='" + index + "']") : [];
      var i;
      for (i = 0; i < options.length; i++) {
        if (options[i].checked || options[i].getAttribute("aria-pressed") === "true" || (options[i].classList && options[i].classList.contains("active"))) {
          return String(options[i].value || options[i].getAttribute("data-value") || options[i].textContent || "").trim();
        }
      }
    } catch (e) {}
    return "";
  }

  function parseVariantsJson(raw) {
    try {
      var parsed = JSON.parse(raw);
      if (parsed && parsed.variants) return parsed.variants;
      if (parsed && parsed.length) return parsed;
    } catch (e) {}
    return null;
  }

  function productVariants(form) {
    try {
      var prod = typeof window !== "undefined" && window.theme ? window.theme.product : null;
      if (prod && prod.variants && prod.variants.length) return prod.variants;
      var raw = "";
      if (form && form.getAttribute) raw = form.getAttribute("data-variants") || "";
      if (!raw && form && form.closest) {
        var holder = form.closest("[data-variants]");
        if (holder) raw = holder.getAttribute("data-variants") || "";
      }
      if (raw) return parseVariantsJson(raw);
    } catch (e) {}
    return null;
  }

  function matchVariantFromOptions(form) {
    try {
      var variants = productVariants(form);
      var prod = typeof window !== "undefined" && window.theme ? window.theme.product : null;
      if (!variants || !variants.length) {
        if (prod && prod.selected_or_first_available_variant && prod.selected_or_first_available_variant.id) {
          return String(prod.selected_or_first_available_variant.id);
        }
        return "";
      }
      var option1 = readOptionValue(form, "option1", 0);
      var option2 = readOptionValue(form, "option2", 1);
      var option3 = readOptionValue(form, "option3", 2);
      if (option1 || option2 || option3) {
        var i;
        for (i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (option1 && String(v.option1) !== option1) continue;
          if (option2 && String(v.option2) !== option2) continue;
          if (option3 && String(v.option3) !== option3) continue;
          if (v.id) return String(v.id);
        }
      }
      if (prod && prod.selected_or_first_available_variant && prod.selected_or_first_available_variant.id) {
        return String(prod.selected_or_first_available_variant.id);
      }
      return variants[0] && variants[0].id ? String(variants[0].id) : "";
    } catch (e) {
      return "";
    }
  }

  function readVariantId(form, fields) {
    var id = "";
    try {
      if (fields && typeof fields.get === "function") id = fields.get("id") || "";
    } catch (e) {}
    if (!id && form && form.querySelector) {
      var input = form.querySelector("select[name='id'], input[name='id']");
      if (input) id = input.value || input.getAttribute("value") || "";
    }
    if (!id && form && form.id && typeof document !== "undefined" && document.querySelector) {
      var linked = document.querySelector("select[name='id'][form='" + form.id + "'], input[name='id'][form='" + form.id + "']");
      if (linked) id = linked.value || linked.getAttribute("value") || "";
    }
    if (!id && form && form.getAttribute) id = form.getAttribute("data-variant-id") || "";
    if (!id && form && form.closest) {
      var marked = form.closest("[data-variant-id]");
      if (marked) id = marked.getAttribute("data-variant-id") || "";
    }
    if (!id) id = matchVariantFromOptions(form);
    return digits(id);
  }

  function readSku(el) {
    try {
      if (!el) return "";
      var sku = "";
      var form = el.closest ? el.closest("form, product-cart-form") : null;
      var variantId = "";
      if (form) {
        var idInput = form.querySelector ? form.querySelector('[name="id"]') : null;
        if (idInput) variantId = idInput.value || "";
      }
      var prod = typeof window !== "undefined" && window.theme ? window.theme.product : null;
      if (prod && prod.variants && variantId) {
        var i;
        for (i = 0; i < prod.variants.length; i++) {
          if (String(prod.variants[i].id) === String(variantId) && prod.variants[i].sku) {
            sku = prod.variants[i].sku;
            break;
          }
        }
      }
      if (!sku && el.getAttribute) {
        sku = el.getAttribute("data-sku") || el.getAttribute("data-product-sku") || "";
      }
      if (!sku && el.closest) {
        var marked = el.closest("[data-sku], [data-product-sku]");
        if (marked) sku = marked.getAttribute("data-sku") || marked.getAttribute("data-product-sku") || "";
      }
      if (!sku && el.querySelector) {
        var text = el.querySelector(".product-card-title-sku, .cart-item-product-sku, .cart-cross-sell-card__sku");
        if (text) sku = String(text.textContent || "").replace(/\s+/g, " ").trim();
      }
      if (!sku && prod) {
        var selected = prod.selected_or_first_available_variant || (prod.variants && prod.variants[0]);
        if (selected && selected.sku) sku = selected.sku;
      }
      sku = String(sku || "").replace(/\s+/g, " ").trim();
      return sku.length > 60 ? sku.slice(0, 60) : sku;
    } catch (e) {
      return "";
    }
  }

  function extraObject(raw) {
    if (!raw || typeof raw !== "object") return null;
    var out = {};
    var key;
    for (key in raw) {
      if (!Object.prototype.hasOwnProperty.call(raw, key)) continue;
      var value = raw[key];
      if (value == null || value === "") continue;
      out[clip(key, 40)] = clip(String(value), 80);
    }
    try {
      if (JSON.stringify(out).length > 512) return null;
    } catch (e) {
      return null;
    }
    return out;
  }

  function sanitizeEvent(ev, fields) {
    var data = fields && typeof fields === "object" ? fields : {};
    var event = {
      ev: clip(ev, 40),
      t: Date.now(),
      page: data.page || currentPage(),
      path: data.path || currentPath(),
      device: device
    };
    if (data.ref) event.ref = clip(data.ref, 100);
    if (data.landing === true) event.landing = true;
    if (data.surface) event.surface = clip(data.surface, 40);
    if (data.group) event.group = clip(data.group, 40);
    if (data.value) event.value = clip(scrubJourneyLabel(data.value), 80);
    if (data.label) event.label = clip(scrubJourneyLabel(data.label), 60);
    if (data.tag) event.tag = clip(data.tag, 16);
    if (data.href) event.href = clip(data.href, 200);
    if (data.product_id) event.product_id = digits(data.product_id);
    if (data.variant_id) event.variant_id = digits(data.variant_id);
    if (data.sku) event.sku = clip(String(data.sku), 60);
    if (data.qty != null && isFinite(Number(data.qty))) event.qty = Number(data.qty) || 0;
    if (data.source) event.source = clip(data.source, 40);
    if (data.position != null && isFinite(Number(data.position))) event.position = Number(data.position) || 0;
    if (data.collection) event.collection = clip(data.collection, 80);
    if (data.dwell != null && isFinite(Number(data.dwell))) event.dwell = Math.max(0, Number(data.dwell) || 0);
    if (data.msg) {
      var msgCap = event.ev === "atc_fail" ? 120 : 160;
      var scrubbedMsg = scrubJourneyLabel(data.msg);
      if (scrubbedMsg) event.msg = clip(scrubbedMsg, msgCap);
    }
    if (data.src) event.src = clip(String(data.src), 120);
    if (data.line != null && isFinite(Number(data.line))) event.line = Math.max(0, Math.round(Number(data.line)));
    if (data.col != null && isFinite(Number(data.col))) event.col = Math.max(0, Math.round(Number(data.col)));
    if (data.status != null && isFinite(Number(data.status))) event.status = Math.max(0, Math.round(Number(data.status)));
    if (data.lcp != null && isFinite(Number(data.lcp))) event.lcp = Math.max(0, Math.round(Number(data.lcp)));
    if (data.inp != null && isFinite(Number(data.inp))) event.inp = Math.max(0, Math.round(Number(data.inp)));
    if (data.cls != null && isFinite(Number(data.cls))) event.cls = Math.max(0, Math.round(Number(data.cls)));
    if (data.ttfb != null && isFinite(Number(data.ttfb))) event.ttfb = Math.max(0, Math.round(Number(data.ttfb)));
    if (data.fcp != null && isFinite(Number(data.fcp))) event.fcp = Math.max(0, Math.round(Number(data.fcp)));
    if (data.nav && /^(navigate|reload|back_forward|prerender)$/.test(String(data.nav))) event.nav = String(data.nav);
    if (data.lcp_el) event.lcp_el = clip(String(data.lcp_el), 80);
    if (data.lcp_url) event.lcp_url = clip(String(data.lcp_url), 120);
    if (data.utm_source) event.utm_source = clip(String(data.utm_source).toLowerCase(), 60);
    if (data.utm_medium) event.utm_medium = clip(String(data.utm_medium).toLowerCase(), 60);
    if (data.utm_campaign) event.utm_campaign = clip(String(data.utm_campaign).toLowerCase(), 60);
    if (data.click && /^(gclid|gbraid|wbraid|msclkid|fbclid)$/.test(String(data.click))) event.click = String(data.click);
    if (data.ret === 0 || data.ret === 1) event.ret = data.ret;
    var extra = extraObject(data.extra);
    if (extra) event.extra = extra;
    return event;
  }

  function sendJourneyBeacon(payload) {
    try {
      if (window.theme && window.theme.editor) return;
      if (typeof document !== "undefined" && document.prerendering) return;
      var body = JSON.stringify(payload);
      var url = journeyBeaconUrl();
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: "text/plain" });
        if (navigator.sendBeacon(url, blob)) return;
      }
      fetch(url, {
        method: "POST",
        body: body,
        keepalive: true,
        headers: { "Content-Type": "text/plain" }
      }).catch(function () {});
    } catch (e) {}
  }

  function flushQueue() {
    try {
      if (flushTimer) {
        clearTimeout(flushTimer);
        flushTimer = null;
      }
      if (!queue.length) return;
      if (!allowed()) {
        queue = [];
        return;
      }
      rememberFirstVisit();
      var sid = getSearchSessionId();
      var dev = null;
      try {
        if (!sessionStorage.getItem("sfs_dev_sent")) {
          var i;
          for (i = 0; i < queue.length; i++) {
            if (queue[i] && queue[i].ev === "page_view" && queue[i].landing === true) {
              dev = collectJourneyDev();
              break;
            }
          }
        }
      } catch (e) {}
      var payloads = buildJourneyBatch(sid, queue, automation, dev);
      queue = [];
      if (!payloads || !payloads.length) return;
      var p;
      for (p = 0; p < payloads.length; p++) {
        if (!payloads[p] || !payloads[p].events || !payloads[p].events.length) continue;
        if (payloads[p].dev) {
          try { sessionStorage.setItem("sfs_dev_sent", "1"); } catch (e) {}
        }
        sendJourneyBeacon(payloads[p]);
      }
    } catch (e) {
      queue = [];
    }
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = setTimeout(function () {
      flushTimer = null;
      flushQueue();
    }, FLUSH_MS);
  }

  function enqueue(event, immediate) {
    try {
      if (event && event.ev === "add_to_cart") rememberPendingAdd(event);
    } catch (ePend) {}
    queue.push(event);
    if (immediate) flushQueue();
    else scheduleFlush();
  }

  function flushPendingConsent() {
    try {
      var waiting = pendingConsent;
      pendingConsent = [];
      if (!waiting.length) return;
      if (!allowed()) return;
      var i;
      for (i = 0; i < waiting.length; i++) enqueue(waiting[i].event, waiting[i].immediate);
    } catch (e) {}
  }

  function track(ev, fields) {
    try {
      if (!journeyEnabled() || !isSampled()) return;
      if (typeof document !== "undefined" && document.prerendering) return;
      if (window.theme && window.theme.editor) return;
      var event = sanitizeEvent(ev, fields);
      if (!event.ev) return;
      var immediate = event.ev === "checkout_start" || event.ev === "quote_submit";
      if (consentStopped) return;
      if (!consentReady()) {
        if (consentDropped) return;
        if (pendingConsent.length < MAX_PENDING) pendingConsent.push({ event: event, immediate: immediate });
        return;
      }
      if (!allowed()) return;
      enqueue(event, immediate);
    } catch (e) {}
  }

  function visibleText(el) {
    try {
      return String(el && (el.textContent || "")).replace(/\s+/g, " ").trim();
    } catch (e) {
      return "";
    }
  }

  function clickLabel(el) {
    function take(value) {
      var text = value == null ? "" : String(value).replace(/\s+/g, " ").trim();
      if (!text) return "";
      return text.length > 60 ? text.slice(0, 60) : text;
    }
    try {
      if (!el) return "";
      if (el.closest && el.closest("[data-hub-finder]")) {
        var finderLabel = take(el.getAttribute && el.getAttribute("data-finder-event"));
        if (finderLabel) return finderLabel;
      }
      var label = take(el.getAttribute && el.getAttribute("aria-label"));
      if (label) return label;
      var row = el.closest
        ? el.closest("[data-sfs-label], [data-sku], [data-product-id], li[role='option'], [role='option']")
        : null;
      if (!row) row = el;
      label = take(row.getAttribute && row.getAttribute("aria-label"));
      if (label) return label;
      label = take(row.getAttribute && row.getAttribute("data-sfs-label"));
      if (label) return label;
      label = take(row.getAttribute && row.getAttribute("data-sku"));
      if (label) return label;
      var titleEl = row.querySelector
        ? row.querySelector(".predictive-product-description--primary, .predictive-product-sku, .predictive-product-description, .predictive-product-heading, [data-product-title]")
        : null;
      if (titleEl) {
        label = take((titleEl.textContent || "") || (titleEl.getAttribute && titleEl.getAttribute("title")));
        if (label) return label;
      }
      var titled = row.querySelector ? row.querySelector("a[title], [title]") : null;
      if (titled) {
        label = take(titled.getAttribute("title"));
        if (label) return label;
      }
      label = take(el.textContent);
      if (label) return label;
      return take(row.textContent);
    } catch (e) {
      return "";
    }
  }

  function pathnameOf(href) {
    try {
      if (!href) return "";
      return clip(new URL(href, location.href).pathname, 200);
    } catch (e) {
      return clip(String(href).split("?")[0], 200);
    }
  }

  function collectionHandle() {
    try {
      var marked = document.querySelector("[data-collection-handle]");
      if (marked && marked.getAttribute("data-collection-handle")) {
        return clip(marked.getAttribute("data-collection-handle"), 80);
      }
      var match = location.pathname.match(/\/collections\/([^/]+)/);
      return match ? clip(match[1], 80) : "";
    } catch (e) {
      return "";
    }
  }

  function cartItemCount() {
    try {
      var el = document.querySelector(".jsCartCount[data-count], .attr-count[data-count]");
      if (!el) return null;
      var n = parseInt(el.getAttribute("data-count"), 10);
      return isFinite(n) ? n : null;
    } catch (e) {
      return null;
    }
  }

  function mappedAnalyticsSurface(el) {
    try {
      if (window.SBAnalytics && typeof window.SBAnalytics.surface === "function") {
        var raw = window.SBAnalytics.surface(el);
        if (ANALYTICS_SURFACES[raw]) return ANALYTICS_SURFACES[raw];
        if (raw && raw.indexOf("product_") === 0) {
          var rest = raw.slice(8);
          if (CROSS_SELL_SURFACES[rest]) return CROSS_SELL_SURFACES[rest];
        }
      }
    } catch (e) {}
    return "";
  }

  function landmarkSurface(el) {
    try {
      if (!el || !el.closest) return "";
      if (el.closest("header, [role='banner']")) return "header_menu";
      if (el.closest("footer, [role='contentinfo']")) return "footer";
      if (el.closest("dialog, [role='dialog']")) return "dialog";
      if (el.closest("aside")) return "aside";
      if (el.closest("main")) return "main";
    } catch (e) {}
    return "";
  }

  function searchDropdownRoot(el) {
    try {
      if (!el || !el.closest) return null;
      return el.closest(".js-search-result, #resultContainer, .predictive__search-result, .search-result-container, predictive-search");
    } catch (e) {
      return null;
    }
  }

  function isSimilarItemsProductHit(el) {
    try {
      if (!el || !el.closest) return false;
      if (el.closest(
        "[data-pdp-cross-sell-prev], [data-pdp-cross-sell-next], .pdp-cross-sells__nav, " +
        "[data-cart-cross-sell-prev], [data-cart-cross-sell-next], .tns-controls, .tns-nav, " +
        "[data-controls], [role='tab'], [data-sfs-show-more], .facet-guide__more"
      )) {
        return false;
      }
      return !!el.closest(".cart-cross-sell-card, .product-card, [data-product-id], form[action*='/cart/add']");
    } catch (e) {
      return false;
    }
  }

  function journeySurface(el) {
    if (!el || !el.closest) return "other";
    if (el.closest("[data-hub-finder]")) return "hub_finder";
    var marked = el.closest("[data-sb-surface]");
    if (marked) return clip(marked.getAttribute("data-sb-surface") || "other", 40);
    if (searchDropdownRoot(el)) return "search_dropdown";
    if (el.closest("hub-breaker-browse") && location.pathname === "/collections/circuit-breakers") return "breakers_hub";
    if (el.closest(".list-products, .search-results-body, .search-product-list") && currentPage() === "search") return "search_results";
    if (el.closest("[data-facet-guide]")) return "guided_filters";
    if (el.closest(".slider-filter")) return "top_strip";
    if (el.closest("[data-sfs-filter-rail], .sidebar-section, [id^='FilterDrawer'], .filter-block, accordion-component, [data-filter-id], [data-sfs-query-filters]")) return filterSurface(el);
    if (el.closest(".collection-active-filters, .filter-active, [data-sfs-active-controls]")) return "active_chips";
    var rec = el.closest("[data-cross-sell-source]");
    if (rec) {
      var source = rec.getAttribute("data-cross-sell-source") || "";
      var mappedCross = CROSS_SELL_SURFACES[source] || "cross_sell";
      if (mappedCross === "similar_items") {
        return isSimilarItemsProductHit(el) ? "similar_items" : "similar_items_control";
      }
      return mappedCross;
    }
    if (el.closest("cart-cross-sells, [data-cart-cross-sells]")) return "purchase_addons";
    if (el.closest(".product-bundle, .bundle-content")) return "fbt";
    if (el.closest(".section-featured-collections, [data-section-type='featured-collections']")) return "recently_viewed";
    if (el.closest(".sb-home-hero")) return "hero";
    if (el.closest(".sb-home-catalog, .homepage-card-grid, .sb-landing-catalog")) return "category_tile";
    if (el.closest(".homepage-brand-band, .hp-breaker-brands")) return "brand_tile";
    if (el.closest(".mega__section, brand-mega-component, .brand-mega")) return "mega_menu";
    if (el.closest("#mobileMenu, #mobileMenuPanel, .mobile-menu, mobile-navigation, [data-nav-brand]")) return "mobile_nav";
    if (el.closest(".main-navigation, .section-navigation")) return "header_menu";
    if (el.closest(".breadcrumb-list, nav[aria-label='Breadcrumb']")) return "breadcrumb";
    if (el.closest("#cartDrawer, cart-drawer-component")) return "cart_drawer";
    if (el.closest("#sb-quote-form, .sb-quote-form")) return "quote_form";
    if (el.closest(".search-results-body, .search-product-list, #shopify-section-proxy-search .list-products")) return "search_results";
    if (el.closest(".list-products, .collection-results-body, .collection__products")) {
      return currentPage() === "search" ? "search_results" : "collection_grid";
    }
    var mapped = mappedAnalyticsSurface(el);
    if (mapped) return mapped;
    if (currentPage() === "product") {
      var productLand = landmarkSurface(el);
      if (!productLand || productLand === "main") return "pdp_main";
      return productLand;
    }
    return landmarkSurface(el) || "other";
  }

  function derivedUiSurface(el) {
    if (el && el.closest && el.closest("[data-hub-finder]")) return "hub_finder";
    if (el && el.closest && el.closest(".hub-path__jump-links") && el.closest("hub-collection-nav")) return "breakers_hub";
    var named = journeySurface(el);
    if (named && named !== "other") return named;
    return landmarkSurface(el) || "other";
  }

  function listPosition(card) {
    try {
      var parent = card.parentElement;
      if (!parent) return 0;
      var i = 0;
      var child;
      for (child = parent.firstElementChild; child; child = child.nextElementSibling) {
        var hit = child.hasAttribute && child.hasAttribute("data-product-id")
          ? child
          : (child.querySelector ? child.querySelector("[data-product-id]") : null);
        if (!hit) continue;
        if (hit === card || child === card) return i;
        i++;
      }
      return i;
    } catch (e) {
      return 0;
    }
  }

  function readProductSources() {
    try {
      return JSON.parse(sessionStorage.getItem(PRODUCT_SOURCES_KEY) || "{}") || {};
    } catch (e) {
      return {};
    }
  }

  function writeProductSources(entries) {
    try {
      sessionStorage.setItem(PRODUCT_SOURCES_KEY, JSON.stringify(entries || {}));
    } catch (e) {}
  }

  function rememberFeatureSource(productKey, feature) {
    try {
      if (!allowed() || !productKey || !feature) return;
      var key = String(productKey);
      var value = clip(String(feature), 40);
      if (!key || !value) return;
      var entries = readProductSources();
      entries[key] = { feature: value, at: Date.now() };
      var keys = Object.keys(entries);
      if (keys.length > FEATURE_SOURCE_CAP) {
        keys.sort(function (a, b) {
          return (entries[a].at || 0) - (entries[b].at || 0);
        });
        var drop = keys.length - FEATURE_SOURCE_CAP;
        var i;
        for (i = 0; i < drop; i++) delete entries[keys[i]];
      }
      writeProductSources(entries);
    } catch (e) {}
  }

  function lookupFeatureSource(productKey) {
    try {
      if (!productKey) return "";
      var row = readProductSources()[String(productKey)];
      return row && row.feature ? clip(String(row.feature), 40) : "";
    } catch (e) {
      return "";
    }
  }

  function productHandleFromPath(path) {
    try {
      var match = String(path || "").match(/\/products\/([^/?#]+)/i);
      if (!match) return "";
      return decodeURIComponent(match[1]);
    } catch (e) {
      return "";
    }
  }

  function featureFromSurface(surface) {
    if (!surface) return "";
    return FEATURE_SOURCE_SURFACES[surface] || "";
  }

  function recordFeatureClick(el, surface, productId) {
    try {
      var feature = featureFromSurface(surface);
      if (!feature) return;
      if (productId) rememberFeatureSource(productId, feature);
      var hrefNode = el && el.closest ? el.closest("a[href]") : null;
      var handle = productHandleFromPath(hrefNode ? pathnameOf(hrefNode.getAttribute("href")) : "");
      if (handle) rememberFeatureSource(handle, feature);
    } catch (e) {}
  }

  function resolveStoredFeature(productId, handle) {
    return lookupFeatureSource(productId) || lookupFeatureSource(handle) || "";
  }

  function stampFeatureProperty(form, feature) {
    try {
      if (!form || !feature || !allowed()) return;
      var value = clip(String(feature), 40);
      if (!value) return;
      var existing = form.querySelector ? form.querySelector('[name="properties[_sb_feature]"]') : null;
      if (existing) {
        existing.value = value;
        return;
      }
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_sb_feature]";
      input.value = value;
      form.appendChild(input);
    } catch (e) {}
  }

  function readPendingAdds() {
    try {
      var raw = sessionStorage.getItem(PENDING_ADD_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writePendingAdds(list) {
    try {
      if (!list || !list.length) {
        sessionStorage.removeItem(PENDING_ADD_KEY);
        return;
      }
      sessionStorage.setItem(PENDING_ADD_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function prunePendingAdds(list) {
    var now = Date.now();
    var kept = [];
    var i;
    for (i = 0; i < (list || []).length; i++) {
      var row = list[i];
      if (!row || typeof row !== "object") continue;
      var at = Number(row.at) || 0;
      if (!at || now - at > PENDING_ADD_TTL_MS) continue;
      kept.push(row);
    }
    if (kept.length > PENDING_ADD_CAP) kept = kept.slice(kept.length - PENDING_ADD_CAP);
    return kept;
  }

  function cartRootPath() {
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return String(window.Shopify.routes.root);
      }
    } catch (e) {}
    return "/";
  }

  function rememberPendingAdd(event) {
    try {
      if (!allowed() || !event) return;
      var variantId = event.variant_id ? digits(event.variant_id) : "";
      var productId = event.product_id ? digits(event.product_id) : "";
      if (!variantId && !productId) return;
      var sid = getSearchSessionId();
      if (!sid || !SID_RE.test(sid)) return;
      var row = {
        variant_id: variantId,
        product_id: productId,
        sku: event.sku ? clip(String(event.sku), 60) : "",
        qty: event.qty != null && isFinite(Number(event.qty)) ? Number(event.qty) : 1,
        source: event.source ? clip(String(event.source), 40) : "",
        sid: sid,
        at: Date.now()
      };
      var list = prunePendingAdds(readPendingAdds());
      list.push(row);
      writePendingAdds(prunePendingAdds(list));
    } catch (e) {}
  }

  function pendingMatchesFields(row, fields) {
    if (!row || !fields) return false;
    var variantId = fields.variant_id ? digits(fields.variant_id) : "";
    var productId = fields.product_id ? digits(fields.product_id) : "";
    if (variantId && row.variant_id && String(row.variant_id) === String(variantId)) return true;
    if (!variantId && productId && row.product_id && String(row.product_id) === String(productId)) return true;
    if (variantId && !row.variant_id && productId && row.product_id && String(row.product_id) === String(productId)) {
      return true;
    }
    return false;
  }

  function clearPendingAddMatch(fields) {
    try {
      if (!allowed()) return;
      var data = fields && typeof fields === "object" ? fields : {};
      var list = prunePendingAdds(readPendingAdds());
      if (!list.length) return;
      var next = [];
      var i;
      for (i = 0; i < list.length; i++) {
        if (!pendingMatchesFields(list[i], data)) next.push(list[i]);
      }
      writePendingAdds(next);
    } catch (e) {}
  }

  function cartHasPending(items, row) {
    if (!row || !items || !items.length) return false;
    var i;
    for (i = 0; i < items.length; i++) {
      var item = items[i];
      if (!item) continue;
      var itemVariant = digits(item.variant_id || item.id || "");
      var itemProduct = digits(item.product_id || "");
      if (row.variant_id && itemVariant && String(row.variant_id) === String(itemVariant)) return true;
      if (!row.variant_id && row.product_id && itemProduct && String(row.product_id) === String(itemProduct)) {
        return true;
      }
    }
    return false;
  }

  function fetchCartJs() {
    return fetch(cartRootPath() + "cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }
    }).then(function (res) {
      if (!res || !res.ok) throw new Error("cart");
      return res.json();
    });
  }

  function applyPendingConfirm(cart, rows) {
    var items = cart && cart.items ? cart.items : [];
    var matched = [];
    var missing = [];
    var j;
    for (j = 0; j < (rows || []).length; j++) {
      var row = rows[j];
      if (!row) continue;
      if (cartHasPending(items, row)) {
        matched.push(row);
        track("add_to_cart_ok", {
          product_id: row.product_id || "",
          variant_id: row.variant_id || "",
          sku: row.sku || "",
          qty: row.qty != null ? row.qty : 1,
          source: row.source || "",
          extra: { via: "next_page" }
        });
        ensureCartSessionTag();
      } else {
        missing.push(row);
      }
    }
    if (matched.length) {
      var current = prunePendingAdds(readPendingAdds());
      var next = [];
      var k;
      for (k = 0; k < current.length; k++) {
        var keep = true;
        var m;
        for (m = 0; m < matched.length; m++) {
          if (pendingMatchesFields(current[k], matched[m])) {
            keep = false;
            break;
          }
        }
        if (keep) next.push(current[k]);
      }
      writePendingAdds(prunePendingAdds(next));
    }
    return missing;
  }

  function confirmPendingAdds() {
    try {
      if (pendingAddConfirmRan) return;
      if (!allowed()) return;
      var sid = getSearchSessionId();
      if (!sid || !SID_RE.test(sid)) return;
      var list = prunePendingAdds(readPendingAdds());
      var relevant = [];
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i] && list[i].sid === sid) relevant.push(list[i]);
      }
      writePendingAdds(list);
      if (!relevant.length) return;
      pendingAddConfirmRan = true;
      fetchCartJs()
        .then(function (cart) {
          try {
            if (!allowed()) return;
            var missing = applyPendingConfirm(cart, relevant);
            if (!missing.length) return;
            setTimeout(function () {
              try {
                if (!allowed()) return;
                fetchCartJs()
                  .then(function (cart2) {
                    try {
                      if (!allowed()) return;
                      applyPendingConfirm(cart2, missing);
                    } catch (eRetryThen) {}
                  })
                  .catch(function () {});
              } catch (eRetry) {}
            }, 2500);
          } catch (eThen) {}
        })
        .catch(function () {});
    } catch (e) {}
  }

  function ensureCartSessionTag() {
    try {
      if (!allowed()) return;
      var sid = getSearchSessionId();
      if (!sid || !SID_RE.test(sid)) return;
      var last = "";
      try { last = sessionStorage.getItem(CART_SID_KEY) || ""; } catch (e1) {}
      if (last === sid) return;
      try { sessionStorage.setItem(CART_SID_KEY, sid); } catch (e2) {}
      var root = "/";
      try {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
          root = window.Shopify.routes.root;
        }
      } catch (e3) {}
      fetch(String(root || "/") + "cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json"
        },
        body: JSON.stringify({ attributes: { _sfs_sid: sid } })
      }).catch(function () {});
    } catch (e) {}
  }

  function ensureCartTagIfNeeded() {
    try {
      if (!allowed()) return;
      var sid = getSearchSessionId();
      if (!sid || !SID_RE.test(sid)) return;
      var last = "";
      try { last = sessionStorage.getItem(CART_SID_KEY) || ""; } catch (e1) {}
      if (last === sid) return;
      var count = cartItemCount();
      if (count === 0) return;
      if (count != null && count > 0) {
        ensureCartSessionTag();
        return;
      }
      fetchCartJs()
        .then(function (cart) {
          try {
            if (!allowed()) return;
            var tagged = "";
            try { tagged = sessionStorage.getItem(CART_SID_KEY) || ""; } catch (e2) {}
            if (tagged === sid) return;
            var n = 0;
            if (cart && cart.item_count != null && isFinite(Number(cart.item_count))) {
              n = Number(cart.item_count);
            } else if (cart && cart.items && cart.items.length) {
              n = cart.items.length;
            }
            if (n > 0) ensureCartSessionTag();
          } catch (eThen) {}
        })
        .catch(function () {});
    } catch (e) {}
  }

  function addOk(fields) {
    try {
      if (!allowed()) return;
      var data = fields && typeof fields === "object" ? fields : {};
      var source = data.source ? clip(String(data.source), 40) : "";
      if (!source) {
        source = resolveStoredFeature(data.product_id, data.handle) || "pdp_main";
      }
      clearPendingAddMatch(data);
      track("add_to_cart_ok", {
        product_id: data.product_id || "",
        variant_id: data.variant_id || "",
        sku: data.sku || "",
        qty: data.qty != null ? data.qty : 1,
        source: source
      });
      ensureCartSessionTag();
    } catch (e) {}
  }

  function addSource(el) {
    var surface = journeySurface(el);
    if (surface === "similar_items") return "similar_items";
    if (surface === "fbt") return "fbt";
    if (surface === "purchase_addons") return "purchase_addon";
    if (surface === "cross_sell") return "cross_sell";
    var productId = "";
    var handle = "";
    try {
      var card = el && el.closest ? el.closest("[data-product-id]") : null;
      if (card) productId = card.getAttribute("data-product-id") || "";
      if (!productId) {
        var analytics = document.querySelector("[data-sb-analytics]");
        if (analytics) productId = analytics.getAttribute("data-product-id") || "";
      }
      handle = productHandleFromPath(location.pathname);
    } catch (e) {}
    var stored = resolveStoredFeature(productId, handle);
    if (stored) return stored;
    if (surface === "pdp_main" || currentPage() === "product") return "pdp_main";
    return clip(surface, 40);
  }

  function isPrivateNode(el) {
    if (!el || !el.closest) return false;
    if (el.closest("[data-sb-private]")) return true;
    var type = String(el.type || "").toLowerCase();
    var name = String(el.name || (el.getAttribute && el.getAttribute("name")) || "").toLowerCase();
    var auto = String(el.autocomplete || "").toLowerCase();
    var blob = type + " " + name + " " + auto;
    if (type === "password" || type === "email" || type === "tel") return true;
    if (/pass|email|phone|tel|address|card|cc-|cvv|cvc|otp/.test(blob)) return true;
    return false;
  }

  function shouldDedupe(el, ev) {
    var now = Date.now();
    if (lastDedupe.el === el && lastDedupe.ev === ev && now - lastDedupe.t < DEDUPE_MS) return true;
    lastDedupe = { el: el, ev: ev, t: now };
    return false;
  }

  function shouldDedupeNamed(ev, windowMs) {
    var now = Date.now();
    var ms = windowMs == null ? DEDUPE_MS : windowMs;
    var prev = lastNamedDedupe[ev] || 0;
    if (prev && now - prev < ms) return true;
    lastNamedDedupe[ev] = now;
    return false;
  }

  function checkoutSurface(el) {
    try {
      if (el && el.closest && el.closest("#cartDrawer, cart-drawer-component, [data-sb-surface='cart_drawer']")) {
        return "cart_drawer";
      }
    } catch (e) {}
    return "cart_page";
  }

  function slugifyGroup(text) {
    var value = String(text || "").toLowerCase().replace(/^choose\s+/, "").replace(/['"]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    return clip(value, 40);
  }

  function shouldSkipFilterApply(el, value) {
    try {
      if (el && el.closest && el.closest("select[name='sort_by'], [name='sort_by'], .sort-section, [data-sort]")) return true;
      if (el && el.closest && el.closest(".plp-controls-header, .search-results-header, .search-results-footer, .collection-results-footer")) return true;
      var text = value == null ? "" : String(value);
      if (text.length > 80) return true;
      if (text.indexOf("Sort by") !== -1) return true;
    } catch (e) {}
    return false;
  }

  function filterSurface(el) {
    try {
      if (!el || !el.closest) return "side_rail";
      if (el.closest("[data-sb-analytics-surface='guided_filters'], [data-facet-guide], .facet-guide, .facet-guide__option")) return "guided_filters";
      if (el.closest(".slider-filter")) return "top_strip";
      var drawer = el.closest(".sidebar-section-content, [id^='FilterDrawer']");
      if (drawer && drawer.getAttribute("aria-modal") === "true" && drawer.getAttribute("role") === "dialog") return "filter_drawer";
      if (el.closest(".collection-active-filters, .filter-active, [data-sfs-active-controls]")) return "active_chips";
      if (el.closest("[data-sfs-filter-rail], .sidebar-section, [id^='FilterDrawer'], .filter-block, accordion-component, .filter-section, [data-filter-id], [data-sfs-query-filters]")) return "side_rail";
    } catch (e) {}
    return "side_rail";
  }

  function filterGroup(el) {
    try {
      if (!el) return "unknown";
      if (el.matches && el.matches("[data-sfs-clear-filters], .jsFilterReset, [data-sfs-native-clear]")) return "all";
      var param = el.getAttribute && el.getAttribute("data-param");
      if (!param && el.name && el.name.indexOf("filter.") === 0) param = el.name;
      if (el.closest && (el.closest(".sort-section") || el.closest("[name='sort_by']") || (el.name === "sort_by"))) return "sort";
      var group = el.getAttribute && el.getAttribute("data-sfs-group");
      if (group) return clip(group, 40);
      var marked = el.closest && el.closest("[data-sfs-group], [data-filter-group], [data-group], [data-filter-id], [data-facet-key]");
      if (marked) {
        group = marked.getAttribute("data-sfs-group") || marked.getAttribute("data-filter-group") || marked.getAttribute("data-group") || marked.getAttribute("data-filter-id") || marked.getAttribute("data-facet-key");
        if (group) return clip(group, 40);
      }
      var row = el.closest && el.closest(".jsFilterToggle, [data-sfs-filter-item], li");
      if (row && row.querySelector) {
        var keyed = row.querySelector("[data-facet-key], [data-sfs-group], [data-filter-id]");
        if (keyed) {
          group = keyed.getAttribute("data-sfs-group") || keyed.getAttribute("data-filter-id") || keyed.getAttribute("data-facet-key");
          if (group) return clip(group, 40);
        }
      }
      var fieldset = el.closest && el.closest("fieldset");
      if (fieldset) {
        var legend = fieldset.querySelector ? fieldset.querySelector("legend") : null;
        var legendSlug = slugifyGroup(legend ? visibleText(legend) : "");
        if (legendSlug) return legendSlug;
      }
      var headingRoot = el.closest && el.closest(".filter-block, accordion-component, [data-facet-guide], .facet-guide, .facet-guide__options");
      if (headingRoot && headingRoot.closest) {
        var guide = headingRoot.closest("[data-facet-guide], .facet-guide");
        if (guide) headingRoot = guide;
      }
      var headingEl = headingRoot && headingRoot.querySelector
        ? headingRoot.querySelector(".facet-guide__heading, summary .label, legend, h2, h3")
        : null;
      var headingSlug = slugifyGroup(headingEl ? visibleText(headingEl) : "");
      if (headingSlug) return headingSlug;
      if (param) return slugifyGroup(param.split(".").pop());
    } catch (e) {}
    return "unknown";
  }

  function filterValue(el) {
    var label = el.getAttribute && (el.getAttribute("data-sfs-label") || el.getAttribute("data-sfs-group-label"));
    if (label) return label;
    var row = el.closest && el.closest("[data-sfs-filter-item], .jsFilterToggle");
    if (row) {
      var span = row.querySelector && row.querySelector(".text");
      if (span) return visibleText(span);
    }
    var nativeValue = el.querySelector && el.querySelector(".jsValue, .text");
    if (nativeValue) return visibleText(nativeValue);
    if (el.value) return clip(el.value, 80);
    return visibleText(el);
  }

  function menuLinkFields(anchor, surface) {
    var column = anchor.closest(".breaker-menu__subgroup, .breaker-menu__group, .mega__block, .mega-column, .mobile-navigation-layer, .header-icon-item");
    var root = anchor.closest(".breaker-menu, .mega__section, .mobile-navigation-layer, #mobileMenuPanel, header, .main-navigation") || anchor.parentElement;
    var heading = column && column.querySelector("h2, h3, .mega__block-title, .mobile-navigation-title, .breaker-menu__aside-heading");
    var list = anchor.closest("ul") || column || anchor.parentElement;
    var links = list ? list.querySelectorAll("a[href]") : [anchor];
    var columns = root ? root.querySelectorAll(".breaker-menu__group, .mega__block, .mega-column, .header-icon-item") : [];
    var columnIndexNode = column && (column.closest(".breaker-menu__group") || column);
    var position = Array.prototype.indexOf.call(links, anchor) + 1;
    var col = Array.prototype.indexOf.call(columns, columnIndexNode) + 1;
    var label = /^tel:/i.test(anchor.getAttribute("href") || "") ? "Call a specialist" : clickLabel(anchor);
    return {
      surface: surface, label: label, value: label,
      href: pathnameOf(anchor.getAttribute("href")),
      group: clip(scrubJourneyLabel(heading ? visibleText(heading) : label), 40),
      position: Math.min(500, Math.max(1, position)),
      extra: { href: pathnameOf(anchor.getAttribute("href")), col: String(Math.max(1, col)),
        level: surface === "header_menu" || anchor.closest(".main-layer, .main-menu") ? "top" : "flyout" }
    };
  }

  function hubClickFields(ui) {
    var title = ui.querySelector(".sb-hub-card__title, .hub-path__brand-row-name, .hub-path__amp-label, .hub-path__parts-label");
    var count = ui.querySelector(".hub-path__value-count");
    var anchor = ui.closest("a[href]");
    var href = anchor ? anchor.getAttribute("href") : "";
    var hash = "";
    try { hash = new URL(href, location.href).hash; } catch (e) {}
    return { surface: "breakers_hub", label: title ? visibleText(title) : clickLabel(ui),
      tag: (ui.tagName || "").toLowerCase(), href: href ? clip(pathnameOf(href) + hash, 200) : "",
      group: ui.closest(".hub-path__jump-links") ? "jump" :
        ui.closest("breaker-progressive-finder, .breaker-finder, #hub-finder") ? "finder" : "tile",
      extra: { count: count ? clip(visibleText(count), 80) : "" } };
  }

  // Each accepted intent owns its timeout and completion. A later result
  // cannot complete an earlier request that was skipped or superseded.
  function filterStart(el, action) {
    try {
      if (!el || !el.closest || el.disabled || el.getAttribute("aria-disabled") === "true") return null;
      if (el.matches("[data-sfs-clear-filters], .jsFilterReset, [data-sfs-native-clear]")) return null;
      var group = filterGroup(el);
      var value = filterValue(el);
      if (shouldSkipFilterApply(el, value)) return null;
      var remove = el.matches("[data-sfs-remove-filter], .jsFilterRemove");
      var host = el.closest("collection-search-filters");
      var state = host && (host.desiredState || host.currentState);
      var selected = state && state.filters ? (state.filters[group] || []).indexOf(value) !== -1 : null;
      if (remove && selected === false) return null;
      if (!action) {
        var row = el.closest("[data-sfs-filter-item], .jsFilterToggle");
        var input = row && row.querySelector("input[type='checkbox']");
        action = el.type === "checkbox" ? (el.checked ? "add" : "remove") : remove || selected === true || (input && input.checked) || /^Remove\b/i.test(el.getAttribute("aria-label") || "") ? "remove" : "add";
      }
      var intent = { surface: filterSurface(el) === "active_chips" ? "side_rail" : filterSurface(el), group: group, value: value,
        collection: collectionHandle(), action: action, done: false };
      intent.timer = setTimeout(function () { filterComplete(intent, null); }, 8000);
      return intent;
    } catch (e) { return null; }
  }

  function filterComplete(intent, root) {
    try {
      if (!intent || intent.done) return;
      intent.done = true;
      clearTimeout(intent.timer);
      if (intent.navigation) {
        try {
          var saved = JSON.parse(sessionStorage.getItem("sfs_journey_filter_navigation") || "null");
          if (saved && saved.navigation === intent.navigation) sessionStorage.removeItem("sfs_journey_filter_navigation");
        } catch (eStore) {}
      }
      var count = root && root.querySelector("[data-search-results-total], .collection-count, .search-count, .jsFilterResultCount");
      var raw = count && (count.getAttribute("data-search-results-total") || count.textContent);
      var match = raw && String(raw).match(/\d[\d,]*/);
      track("filter_apply", { surface: intent.surface, group: intent.group, value: intent.value,
        collection: intent.collection, extra: { action: intent.action,
          results: match ? match[0].replace(/,/g, "") : "error" } });
    } catch (e) {}
  }

  function emitFilterClear(el) {
    try {
      if (!el) return;
      var now = Date.now();
      if (filterClearTimes.has(el) && now - filterClearTimes.get(el) < DEDUPE_MS) return;
      filterClearTimes.set(el, now);
      track("filter_clear", { surface: filterSurface(el), group: filterGroup(el),
        value: filterValue(el), collection: collectionHandle() });
    } catch (e) {}
  }

  function filterNavigate(el, href, action) {
    var intent = filterStart(el, action);
    if (!intent || !allowed()) return;
    try {
      intent.navigation = String(Date.now()) + ":" + String(Math.random());
      sessionStorage.setItem("sfs_journey_filter_navigation", JSON.stringify({
        surface: intent.surface, group: intent.group, value: intent.value,
        collection: intent.collection, action: intent.action, at: Date.now(), navigation: intent.navigation,
        path: pathnameOf(href)
      }));
    } catch (e) {}
  }

  function resumeFilterNavigation() {
    try {
      var raw = sessionStorage.getItem("sfs_journey_filter_navigation");
      if (!raw) return;
      sessionStorage.removeItem("sfs_journey_filter_navigation");
      var intent = JSON.parse(raw);
      if (trackingState() === "deny" || intent.path !== location.pathname) return;
      filterComplete(intent, Date.now() - intent.at < 8000 ? document : null);
    } catch (e) {}
  }

  function bindFilterCommits() {
    var analytics = window.SBAnalytics;
    if (!analytics || typeof analytics.filterIntent !== "function" || typeof analytics.filterCommit !== "function") return;
    var intents = new WeakMap();
    var originalIntent = analytics.filterIntent;
    var originalCommit = analytics.filterCommit;
    analytics.filterIntent = function (el) {
      var intent = originalIntent.apply(this, arguments);
      if (intent) intents.set(intent, filterStart(el));
      return intent;
    };
    analytics.filterCommit = function (intent, root) {
      filterComplete(intent && intents.get(intent), root);
      return originalCommit.apply(this, arguments);
    };
  }

  function isMenuRoot(node) {
    try {
      if (!node || !node.matches) return false;
      return node.matches(
        ".mega__section, [data-sb-surface='mega_menu'], #mobileMenu, #mobileMenuPanel, [data-sb-surface='mobile_nav'], #cartDrawer, cart-drawer-component, [data-sb-surface='cart_drawer']"
      );
    } catch (e) {
      return false;
    }
  }

  function menuSurfaceFrom(el) {
    try {
      if (!el || !el.closest) return "";
      if (el.closest("#cartDrawer, cart-drawer-component, [data-sb-surface='cart_drawer']")) return "cart_drawer";
      if (el.closest("#mobileMenu, #mobileMenuPanel, .mobile-menu, mobile-navigation, [data-sb-surface='mobile_nav']")) return "mobile_nav";
      if (el.closest(".mega__section, brand-mega-component, .brand-mega, [data-sb-surface='mega_menu']")) return "mega_menu";
      if (el.closest("[data-sfs-filter-rail], .sidebar-section, [id^='FilterDrawer']")) return "side_rail";
    } catch (e) {}
    return "";
  }

  function menuSurfaceFromTrigger(el) {
    try {
      var controls = el && el.getAttribute && el.getAttribute("aria-controls");
      if (controls && typeof document !== "undefined" && document.getElementById) {
        var panel = document.getElementById(controls);
        var fromPanel = menuSurfaceFrom(panel);
        if (fromPanel) return fromPanel;
      }
      var item = el && el.closest && el.closest(".list-item");
      var flyout = item && item.querySelector && item.querySelector(".mega__section, .dropdown, [data-sb-surface='mega_menu']");
      if (flyout) return "mega_menu";
      if (el && el.closest && el.closest(".header-icon--hambuger, .js-popup-toggle, [aria-controls='mobileMenu']")) return "mobile_nav";
    } catch (e) {}
    return menuSurfaceFrom(el);
  }

  function setMenuOpen(surface, open) {
    try {
      surface = clip(surface, 40);
      if (!surface) return;
      var was = !!openMenus[surface];
      if (open) {
        if (was) return;
        openMenus[surface] = true;
        track("menu_open", { surface: surface });
      } else {
        if (!was) return;
        openMenus[surface] = false;
        track("menu_close", { surface: surface });
      }
    } catch (e) {}
  }

  function closeAllOpenMenus() {
    var key;
    for (key in openMenus) {
      if (Object.prototype.hasOwnProperty.call(openMenus, key) && openMenus[key]) {
        setMenuOpen(key, false);
      }
    }
  }

  function bindMenuObserver() {
    try {
      if (typeof MutationObserver === "undefined" || !document.documentElement) return;
      var observer = new MutationObserver(function (records) {
        var r;
        for (r = 0; r < records.length; r++) {
          try {
            var node = records[r].target;
            if (!isMenuRoot(node)) continue;
            var surface = menuSurfaceFrom(node) || (node.getAttribute && node.getAttribute("data-sb-surface")) || "";
            if (!surface) continue;
            var hidden = node.getAttribute("aria-hidden");
            if (hidden === "true") setMenuOpen(surface, false);
            else if (hidden === "false") setMenuOpen(surface, true);
          } catch (e) {}
        }
      });
      observer.observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ["aria-hidden"]
      });
    } catch (e) {}
  }

  function dropdownPosition(root, row) {
    try {
      if (!root || !root.querySelectorAll) return listPosition(row);
      var items = root.querySelectorAll("[data-product-id], [data-sku]");
      var i;
      for (i = 0; i < items.length; i++) {
        if (items[i] === row) return i;
      }
    } catch (e) {}
    return listPosition(row);
  }

  function isTrackableTextControl(el) {
    try {
      if (!el || !el.matches) return false;
      if (el.matches("textarea")) return true;
      if (!el.matches("input")) return false;
      var type = String((el.getAttribute && el.getAttribute("type")) || el.type || "text").toLowerCase();
      return type === "text" || type === "search" || type === "email" || type === "tel" || type === "number";
    } catch (e) {
      return false;
    }
  }

  function applyLandingFields(fields) {
    try {
      var params = null;
      try { params = new URLSearchParams(location.search || ""); } catch (e1) { params = null; }
      if (params) {
        var utmKeys = ["utm_source", "utm_medium", "utm_campaign"];
        var ui;
        for (ui = 0; ui < utmKeys.length; ui++) {
          var rawUtm = params.get(utmKeys[ui]);
          if (!rawUtm) continue;
          var cleaned = clip(String(rawUtm).toLowerCase(), 60);
          if (cleaned) fields[utmKeys[ui]] = cleaned;
        }
        var clickKeys = ["gclid", "gbraid", "wbraid", "msclkid", "fbclid"];
        for (ui = 0; ui < clickKeys.length; ui++) {
          if (params.get(clickKeys[ui])) {
            fields.click = clickKeys[ui];
            break;
          }
        }
      }
    } catch (e) {}
    try {
      var first = "";
      try { first = localStorage.getItem("sfs_first") || ""; } catch (e2) { first = ""; }
      var today = etSessionDay(Date.now());
      var ret = 0;
      if (/^\d{4}-\d{2}-\d{2}$/.test(first) && today && first < today) ret = 1;
      fields.ret = ret;
    } catch (e) {}
  }

  function productPriceBand(cents) {
    try {
      var p = Number(cents);
      if (!isFinite(p) || p < 0) p = 0;
      if (p === 0) return "0";
      if (p < 10000) return "<100";
      if (p < 50000) return "100-499";
      if (p < 200000) return "500-1999";
      return "2000+";
    } catch (e) {
      return "";
    }
  }

  function productAvailStatus(product, threshold) {
    try {
      if (!product) return "";
      var selected = product.selected_or_first_available_variant;
      if (!selected && product.variants && product.variants.length) selected = product.variants[0];
      if (!selected) return "";
      if (selected.available === true) return "in";
      var price = Number(selected.price);
      var thresh = Number(threshold);
      if (isFinite(price) && isFinite(thresh) && price >= thresh) return "quote";
      return "out";
    } catch (e) {
      return "";
    }
  }

  function productPageViewExtra() {
    try {
      if (currentPage() !== "product") return null;
      var product = null;
      var threshold = 0;
      try {
        if (window.theme) {
          product = window.theme.product || null;
          if (window.theme.stockQuoteThreshold != null) threshold = window.theme.stockQuoteThreshold;
        }
      } catch (eTheme) {
        return null;
      }
      if (!product) return null;
      var selected = product.selected_or_first_available_variant;
      if (!selected && product.variants && product.variants.length) selected = product.variants[0];
      if (!selected) return null;
      var extra = {};
      var avail = productAvailStatus(product, threshold);
      if (avail) extra.avail = avail;
      var band = productPriceBand(selected.price);
      if (band) extra.price_band = band;
      return extra;
    } catch (e) {
      return null;
    }
  }

  function emitPageView() {
    var landing = false;
    try {
      landing = !sessionStorage.getItem("sfs_seen");
      sessionStorage.setItem("sfs_seen", "1");
    } catch (e) {}
    var fields = { landing: landing };
    if (landing) {
      fields.ref = referrerHost();
      try { applyLandingFields(fields); } catch (eLand) {}
    }
    try {
      var pageExtra = productPageViewExtra();
      if (pageExtra) fields.extra = pageExtra;
    } catch (eExtra) {}
    track("page_view", fields);
    if (currentPage() === "cart") {
      var count = cartItemCount();
      var extra = {};
      if (count != null) extra.items = String(count);
      track("cart_view", { surface: "cart_page", extra: extra });
    }
  }

  function lcpElementLabel(el) {
    try {
      if (!el || !el.tagName) return "";
      var tag = String(el.tagName).toLowerCase();
      var id = el.id || (el.getAttribute && el.getAttribute("id")) || "";
      if (id) return clip(tag + "#" + String(id).split(/\s+/)[0], 80);
      var cls = "";
      if (typeof el.className === "string") cls = el.className.split(/\s+/)[0] || "";
      else if (el.classList && el.classList.length) cls = String(el.classList[0] || "");
      if (cls) return clip(tag + "." + cls, 80);
      return clip(tag, 80);
    } catch (e) {
      return "";
    }
  }

  function lcpResourcePath(url) {
    try {
      if (!url) return "";
      var path = "";
      try {
        path = new URL(String(url), location.href).pathname || "";
      } catch (e2) {
        path = String(url).split("?")[0].replace(/^[a-z]+:\/\/[^/]+/i, "");
      }
      return clip(path, 120);
    } catch (e) {
      return "";
    }
  }

  function noteLcp(entry) {
    try {
      if (!entry) return;
      var t = entry.renderTime || entry.loadTime || entry.startTime;
      if (typeof t === "number" && isFinite(t)) vitalLcp = Math.max(0, Math.round(t));
      var label = lcpElementLabel(entry.element);
      if (label) vitalLcpEl = label;
      var path = lcpResourcePath(entry.url);
      if (path) vitalLcpUrl = path;
    } catch (e) {}
  }

  function noteInp(entry, minDur) {
    try {
      if (!entry) return;
      var d = Number(entry.duration);
      if (!isFinite(d) || d < 0) return;
      if (minDur && d < minDur) return;
      vitalInpSeen = true;
      if (vitalInp == null || d > vitalInp) vitalInp = d;
    } catch (e) {}
  }

  function noteCls(entry) {
    try {
      if (!entry || entry.hadRecentInput) return;
      var value = Number(entry.value);
      if (!isFinite(value) || value < 0) return;
      var start = Number(entry.startTime) || 0;
      if (!vitalClsWindow || start - vitalClsLast > 1000 || start - vitalClsWindow > 5000) {
        vitalClsWindow = start;
        vitalClsSession = 0;
      }
      vitalClsLast = start;
      vitalClsSession += value;
      if (vitalClsSession > vitalClsBest) vitalClsBest = vitalClsSession;
      vitalClsSeen = true;
    } catch (e) {}
  }

  function noteFcp(entry) {
    try {
      if (!entry || entry.name !== "first-contentful-paint") return;
      var t = Number(entry.startTime);
      if (!isFinite(t) || t < 0) return;
      vitalFcp = Math.round(t);
    } catch (e) {}
  }

  function resetClsWindow() {
    vitalClsBest = 0;
    vitalClsSeen = false;
    vitalClsSession = 0;
    vitalClsWindow = 0;
    vitalClsLast = 0;
  }

  function readEntryList(type) {
    try {
      if (typeof performance === "undefined" || !performance.getEntriesByType) return null;
      var list = performance.getEntriesByType(type);
      if (!list || !list.length) return null;
      return list;
    } catch (e) {
      return null;
    }
  }

  function snapshotWebVitals() {
    try {
      var navList = readEntryList("navigation");
      if (navList && navList[0]) {
        var nav = navList[0];
        if (nav.type && /^(navigate|reload|back_forward|prerender)$/.test(String(nav.type))) vitalNav = String(nav.type);
        var start = Number(nav.startTime) || 0;
        var end = Number(nav.responseStart);
        if (typeof nav.finalResponseHeadersStart === "number" && isFinite(nav.finalResponseHeadersStart) && nav.finalResponseHeadersStart > 0) {
          end = nav.finalResponseHeadersStart;
        }
        if (isFinite(end)) vitalTtfb = Math.max(0, Math.round(end - start));
      }
    } catch (e) {}
    try {
      var paints = readEntryList("paint");
      if (paints) {
        var pi;
        for (pi = 0; pi < paints.length; pi++) noteFcp(paints[pi]);
      }
    } catch (e) {}
    try {
      var lcps = readEntryList("largest-contentful-paint");
      if (lcps) noteLcp(lcps[lcps.length - 1]);
    } catch (e) {}
    try {
      var events = readEntryList("event");
      var firsts = readEntryList("first-input");
      if (events || firsts) {
        vitalInp = null;
        vitalInpSeen = false;
        var ei;
        if (events) {
          for (ei = 0; ei < events.length; ei++) noteInp(events[ei], 40);
        }
        if (firsts) {
          for (ei = 0; ei < firsts.length; ei++) noteInp(firsts[ei], 0);
        }
      }
    } catch (e) {}
    try {
      var shifts = readEntryList("layout-shift");
      if (shifts) {
        resetClsWindow();
        var si;
        for (si = 0; si < shifts.length; si++) noteCls(shifts[si]);
      }
    } catch (e) {}
  }

  function observeWebVitals() {
    try {
      if (typeof PerformanceObserver === "undefined") return;
      try {
        var lcpObs = new PerformanceObserver(function (list) {
          try {
            var entries = list.getEntries();
            if (entries && entries.length) noteLcp(entries[entries.length - 1]);
          } catch (e) {}
        });
        lcpObs.observe({ type: "largest-contentful-paint", buffered: true });
      } catch (e) {}
      try {
        var inpObs = new PerformanceObserver(function (list) {
          try {
            var entries = list.getEntries();
            var i;
            for (i = 0; entries && i < entries.length; i++) noteInp(entries[i], 0);
          } catch (e) {}
        });
        inpObs.observe({ type: "event", durationThreshold: 40, buffered: true });
      } catch (e) {}
      try {
        var firstObs = new PerformanceObserver(function (list) {
          try {
            var entries = list.getEntries();
            var i;
            for (i = 0; entries && i < entries.length; i++) noteInp(entries[i], 0);
          } catch (e) {}
        });
        firstObs.observe({ type: "first-input", buffered: true });
      } catch (e) {}
      try {
        var clsObs = new PerformanceObserver(function (list) {
          try {
            var entries = list.getEntries();
            var i;
            for (i = 0; entries && i < entries.length; i++) noteCls(entries[i]);
          } catch (e) {}
        });
        clsObs.observe({ type: "layout-shift", buffered: true });
      } catch (e) {}
      try {
        var fcpObs = new PerformanceObserver(function (list) {
          try {
            var entries = list.getEntries();
            var i;
            for (i = 0; entries && i < entries.length; i++) noteFcp(entries[i]);
          } catch (e) {}
        });
        fcpObs.observe({ type: "paint", buffered: true });
      } catch (e) {}
    } catch (e) {}
  }

  function emitWebVital() {
    try {
      if (webVitalSent) return;
      webVitalSent = true;
      try { snapshotWebVitals(); } catch (eSnap) {}
      var fields = {};
      if (vitalLcp != null) fields.lcp = vitalLcp;
      if (vitalInpSeen && vitalInp != null) fields.inp = Math.round(vitalInp);
      if (vitalClsSeen) fields.cls = Math.round(vitalClsBest * 1000);
      if (vitalTtfb != null) fields.ttfb = vitalTtfb;
      if (vitalFcp != null) fields.fcp = vitalFcp;
      if (vitalNav) fields.nav = vitalNav;
      if (vitalLcpEl) fields.lcp_el = vitalLcpEl;
      if (vitalLcpUrl) fields.lcp_url = vitalLcpUrl;
      track("web_vital", fields);
    } catch (e) {}
  }

  function scriptBaseName(src) {
    try {
      if (!src) return "";
      var clean = String(src).split("?")[0].split("#")[0];
      var slash = clean.lastIndexOf("/");
      var base = slash >= 0 ? clean.slice(slash + 1) : clean;
      return clip(base, 120);
    } catch (e) {
      return "";
    }
  }

  function reportJsError(msg, src, line, col) {
    try {
      if (jsErrorCount >= 5) return;
      var rawSrc = src == null ? "" : String(src);
      if (/^(chrome-extension|moz-extension|safari-extension):/i.test(rawSrc)) return;
      var text = clip(scrubJourneyLabel(msg), 160);
      var base = scriptBaseName(rawSrc);
      if ((!text || text === "Script error.") && !base) return;
      var key = text + "|" + base + "|" + String(line == null ? "" : line);
      if (jsErrorSeen[key]) return;
      jsErrorSeen[key] = 1;
      jsErrorCount += 1;
      var fields = {};
      if (text) fields.msg = text;
      if (base) fields.src = base;
      if (line != null && isFinite(Number(line))) fields.line = Number(line);
      if (col != null && isFinite(Number(col))) fields.col = Number(col);
      track("js_error", fields);
    } catch (e) {}
  }

  function bindJsErrors() {
    try {
      window.addEventListener("error", function (event) {
        try {
          reportJsError(event && event.message, event && event.filename, event && event.lineno, event && event.colno);
        } catch (e) {}
      });
    } catch (e) {}
    try {
      window.addEventListener("unhandledrejection", function (event) {
        try {
          var reason = event && event.reason;
          var msg = "";
          var src = "";
          var line = null;
          var col = null;
          if (reason && typeof reason === "object") {
            msg = reason.message || "";
            src = reason.fileName || reason.filename || "";
            if (reason.lineNumber != null) line = reason.lineNumber;
            if (reason.columnNumber != null) col = reason.columnNumber;
          } else {
            msg = reason == null ? "" : String(reason);
          }
          reportJsError(msg, src, line, col);
        } catch (e) {}
      });
    } catch (e) {}
  }

  function onPageHide() {
    try {
      try { emitWebVital(); } catch (eVital) {}
      if (!pageHideSent) {
        pageHideSent = true;
        closeAllOpenMenus();
        track("page_hide", { dwell: Date.now() - pageStart });
      }
      flushQueue();
    } catch (e) {}
  }

  function onClick(event) {
    try {
      if (event.button > 0) return;
      var target = event.target;
      if (!target || !target.closest) return;

      var tracked = target.closest("[data-sb-track]");
      if (tracked && !shouldDedupe(tracked, tracked.getAttribute("data-sb-track"))) {
        track(tracked.getAttribute("data-sb-track"), {
          surface: tracked.getAttribute("data-sb-surface") || journeySurface(tracked),
          value: tracked.getAttribute("data-sb-value") || visibleText(tracked)
        });
      }

      var ui = target.closest("a, button, [role='button'], input[type='submit'], summary, label[for], [data-sb-track]");
      var menuAnchor = target.closest("a[href]");
      var menuLink = menuAnchor && /^(mega_menu|mobile_nav|header_menu)$/.test(journeySurface(menuAnchor));
      if (ui && !menuLink && !isPrivateNode(ui) && !shouldDedupe(ui, "ui_click")) {
        var hrefNode = ui.closest("a[href]");
        track("ui_click", derivedUiSurface(ui) === "breakers_hub" ? hubClickFields(ui) : {
          surface: derivedUiSurface(ui),
          label: ui.getAttribute("data-sb-value") || clickLabel(ui),
          tag: (ui.tagName || "").toLowerCase(),
          href: hrefNode ? pathnameOf(hrefNode.getAttribute("href")) : "",
          extra: {
            role: ui.getAttribute("role") || "",
            aria: clip(ui.getAttribute("aria-label") || "", 60)
          }
        });
      }

      var expanded = target.closest("[aria-expanded]");
      if (expanded) {
        var was = expanded.getAttribute("aria-expanded");
        requestAnimationFrame(function () {
          try {
            var now = expanded.getAttribute("aria-expanded");
            if (now === was) return;
            var surface = menuSurfaceFromTrigger(expanded) || menuSurfaceFrom(expanded);
            if (surface) setMenuOpen(surface, now === "true");
          } catch (e) {}
        });
      }
      if (target.closest(".jsCartDrawer")) setMenuOpen("cart_drawer", true);
      var menuClose = target.closest("[data-close], .jsMenuClose, .mobile-menu-close, .jsClose, .popup-layer");
      if (menuClose) {
        var closeSurface = menuSurfaceFrom(menuClose) || menuSurfaceFromTrigger(menuClose);
        if (closeSurface) setMenuOpen(closeSurface, false);
      }
      var filterToggle = target.closest("[data-class-name='filter-toggle']");
      if (filterToggle && !shouldDedupe(filterToggle, "menu_filter")) {
        var opening = filterToggle.getAttribute("data-class-rule") !== "remove";
        setMenuOpen("side_rail", opening);
      }

      var checkout = target.closest(
        "button[name='checkout'], [name='checkout'], a[href*='/checkout'], .shopify-payment-button, .additional-checkout-buttons, .js-dynamic-checkout, shopify-accelerated-checkout, [data-shopify-buttoncontainer]"
      );
      if (checkout && !shouldDedupeNamed("checkout_start", 1000)) {
        track("checkout_start", { surface: checkoutSurface(checkout) });
      }

      var quoteCta = target.closest("a[href*='/pages/get-a-quote']");
      if (quoteCta && currentPage() === "product") {
        if (!shouldDedupe(quoteCta, "nav_click_quote")) {
          track("nav_click", { surface: "pdp_main", value: "get a quote", extra: { href: pathnameOf(quoteCta.href) } });
        }
      }

      var anchor = target.closest("a[href]");
      if (anchor) {
        var surface = journeySurface(anchor);
        if (NAV_SURFACES[surface] && !shouldDedupe(anchor, "nav_click")) {
          track("nav_click", menuLink ? menuLinkFields(anchor, surface) : {
            surface: surface,
            value: visibleText(anchor) || anchor.getAttribute("aria-label") || "",
            extra: { href: pathnameOf(anchor.getAttribute("href")) }
          });
        }
      }

      var filterClear = target.closest("[data-sfs-clear-filters], .jsFilterReset, [data-sfs-remove-filter], .jsFilterRemove, [data-sfs-native-clear]");
      if (filterClear) emitFilterClear(filterClear);

      var sortHit = target.closest(".sort-section input[name='sort_by'], .sort-section label, .sort-section summary");
      if (sortHit && !shouldDedupe(sortHit, "sort_change")) {
        var sortInput = target.closest("input[name='sort_by']") || document.getElementById(sortHit.getAttribute("for") || "");
        var sortValue = (sortInput && sortInput.value) || visibleText(sortHit);
        track("sort_change", {
          surface: journeySurface(sortHit),
          group: "sort",
          value: sortValue,
          collection: collectionHandle()
        });
      }

      var dropRoot = searchDropdownRoot(target);
      if (dropRoot) {
        var dropRow = target.closest("[data-product-id], [data-sku]");
        if (!dropRow) {
          var optionRow = target.closest("li[role='option'], [role='option'], button");
          if (optionRow && optionRow.closest) {
            dropRow = optionRow.closest("[data-product-id], [data-sku]") || optionRow;
          } else {
            dropRow = optionRow;
          }
        }
        if (dropRow && (dropRow.getAttribute("data-product-id") || dropRow.getAttribute("data-sku")) && !shouldDedupe(dropRow, "product_click")) {
          recordFeatureClick(dropRow, "search_dropdown", dropRow.getAttribute("data-product-id") || "");
          track("product_click", {
            surface: "search_dropdown",
            product_id: dropRow.getAttribute("data-product-id") || "",
            sku: readSku(dropRow),
            position: dropdownPosition(dropRoot, dropRow)
          });
        }
      } else {
        var card = target.closest("[data-product-id]");
        if (card && !target.closest("button, input, select, textarea, form") && (target.closest("a") || (card.matches && card.matches(".product-card, .cart-cross-sell-card")))) {
          if (!shouldDedupe(card, "product_click")) {
            var cardSurface = journeySurface(card);
            recordFeatureClick(card, cardSurface, card.getAttribute("data-product-id") || "");
            track("product_click", {
              surface: cardSurface,
              product_id: card.getAttribute("data-product-id"),
              sku: readSku(card),
              position: listPosition(card)
            });
          }
        }
      }

      var remove = target.closest("cart-remove-button");
      if (remove && !shouldDedupe(remove, "remove_from_cart")) {
        var line = remove.closest("[data-product-id], .cart-item, .jsCartItem");
        track("remove_from_cart", {
          surface: currentPage() === "cart" ? "cart_page" : "cart_drawer",
          product_id: (line && line.getAttribute("data-product-id")) || "",
          sku: readSku(line || remove)
        });
      }
    } catch (e) {}
  }

  function onSubmit(event) {
    try {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      var action = "";
      try {
        action = new URL(form.getAttribute("action") || form.action || "", location.origin).pathname;
      } catch (e) {
        action = String(form.getAttribute("action") || "");
      }

      var tracked = form.getAttribute("data-sb-track");
      if (tracked) {
        track(tracked, {
          surface: form.getAttribute("data-sb-surface") || journeySurface(form),
          value: form.getAttribute("data-sb-value") || ""
        });
      }

      if (/\/a\/search\/?$|\/search\/?$/.test(action)) {
        track("search_submit", {
          surface: form.closest(".sb-home-hero") ? "homepage_search" : "header_search"
        });
        return;
      }

      if (/\/cart\/add(?:\.js)?$/.test(action)) {
        var fields = null;
        try { fields = new FormData(form); } catch (e) { fields = null; }
        var productCard = form.closest("[data-product-id]");
        var analytics = document.querySelector("[data-sb-analytics]");
        var productId = productCard
          ? productCard.getAttribute("data-product-id")
          : (analytics && analytics.getAttribute("data-product-id")) || "";
        var source = addSource(form);
        var domSurface = journeySurface(form);
        var domFeature = featureFromSurface(
          domSurface === "purchase_addons" ? "purchase_addons" : domSurface
        );
        if (!domFeature && source && source !== "pdp_main") {
          stampFeatureProperty(form, source);
        }
        track("add_to_cart", {
          surface: domSurface,
          source: source,
          product_id: productId,
          variant_id: readVariantId(form, fields),
          qty: fields ? Math.max(1, Number(fields.get("quantity")) || 1) : 1,
          sku: readSku(form)
        });
        return;
      }

      if (/\/cart\/?$/.test(action) && event.submitter && event.submitter.name === "checkout") {
        if (!shouldDedupeNamed("checkout_start", 1000)) {
          track("checkout_start", { surface: checkoutSurface(form) });
        }
        return;
      }

      if (form.id === "sb-quote-form" || (form.classList && form.classList.contains("sb-quote-form")) || (currentPage() === "quote" && form.closest(".sb-form"))) {
        track("quote_submit", { surface: "quote_form" });
        return;
      }

      if (form.id === "customer_login" || /\/account\/login\/?$/.test(action)) {
        track("account_login", { surface: "account" });
      }
    } catch (e) {}
  }

  function onChange(event) {
    try {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches("[name='sort_by']") && !shouldDedupe(target, "sort_change")) {
        track("sort_change", {
          surface: journeySurface(target),
          group: "sort",
          value: target.value || "",
          collection: collectionHandle()
        });
      }
    } catch (e) {}
  }

  function onFocus(event) {
    try {
      var target = event.target;
      if (!target || !target.matches) return;
      if (!isTrackableTextControl(target)) return;
      var quoteField = target.closest && target.closest("#sb-quote-form, .sb-quote-form");
      if (quoteField && !quoteStarted) {
        quoteStarted = true;
        track("quote_start", { surface: "quote_form" });
      }
      var isSearch = target.matches("[name='q'], .js-search-input, [type='search']");
      if (!isSearch && !quoteField) return;
      var fieldKey = target.name || target.id || "field";
      if (inputStarted[fieldKey]) return;
      inputStarted[fieldKey] = 1;
      track("text_input_start", {
        surface: quoteField ? "quote_form" : (target.closest(".sb-home-hero") ? "homepage_search" : "header_search"),
        extra: { field: clip(fieldKey, 80) }
      });
    } catch (e) {}
  }

  function onToggle(event) {
    try {
      var details = event.target;
      if (!details || !details.matches || !details.matches("details")) return;
      var surface = menuSurfaceFrom(details);
      if (surface === "mega_menu" || surface === "mobile_nav" || surface === "cart_drawer") {
        setMenuOpen(surface, !!details.open);
      }
    } catch (e) {}
  }

  function onKeydown(event) {
    try {
      if (!event || event.key !== "Escape") return;
      var openPanel = document.querySelector(
        ".mega__section[aria-hidden='false'], #mobileMenuPanel[aria-hidden='false'], #mobileMenu[aria-hidden='false'], #cartDrawer[aria-hidden='false']"
      );
      if (openPanel) setMenuOpen(menuSurfaceFrom(openPanel), false);
    } catch (e) {}
  }

  function onScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      try {
        var doc = document.documentElement;
        var scrollTop = window.pageYOffset || doc.scrollTop || 0;
        var height = (doc.scrollHeight || 0) - (window.innerHeight || 0);
        if (height <= 0) {
          if (!scrollMarks[100]) {
            scrollMarks[100] = 1;
            track("scroll_depth", { value: "100", extra: { depth: "100" } });
          }
          return;
        }
        var pct = Math.min(100, Math.round((scrollTop / height) * 100));
        var marks = [25, 50, 75, 100];
        var i;
        for (i = 0; i < marks.length; i++) {
          if (pct >= marks[i] && !scrollMarks[marks[i]]) {
            scrollMarks[marks[i]] = 1;
            track("scroll_depth", { value: String(marks[i]), extra: { depth: String(marks[i]) } });
          }
        }
      } catch (e) {}
    });
  }

  function clearTrackingKeys() {
    try { localStorage.removeItem("sfs_session"); } catch (e) {}
    try { localStorage.removeItem("sfs_first"); } catch (e) {}
    try { sessionStorage.removeItem("sfs_sid"); } catch (e) {}
    try { sessionStorage.removeItem(CART_SID_KEY); } catch (e) {}
    try { sessionStorage.removeItem(PRODUCT_SOURCES_KEY); } catch (e) {}
    try { sessionStorage.removeItem(PENDING_ADD_KEY); } catch (e) {}
  }

  function rememberFirstVisit() {
    try {
      if (trackingState() !== "allow") return;
      var first = "";
      try { first = localStorage.getItem("sfs_first") || ""; } catch (e1) { return; }
      if (first) return;
      var today = etSessionDay(Date.now());
      if (!today || !/^\d{4}-\d{2}-\d{2}$/.test(today)) return;
      try { localStorage.setItem("sfs_first", today); } catch (e2) {}
    } catch (e) {}
  }

  function notifyTracking() {
    var state = null;
    try { state = window.sbTrackingAllowed(); } catch (e) { state = false; }
    var i;
    for (i = 0; i < trackingListeners.length; i++) {
      try { trackingListeners[i](state); } catch (e2) {}
    }
  }

  function onVisitorConsent() {
    try {
      var state = trackingState();
      if (state === "deny") {
        consentStopped = true;
        queue = [];
        pendingConsent = [];
        clearTrackingKeys();
        notifyTracking();
        return;
      }
      if (state === "allow") {
        consentStopped = false;
        rememberFirstVisit();
        flushPendingConsent();
        ensureCartTagIfNeeded();
        confirmPendingAdds();
      }
      notifyTracking();
    } catch (e) {}
  }

  function bindConsent() {
    try {
      document.addEventListener("visitorConsentCollected", onVisitorConsent);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], onVisitorConsent);
      }
    } catch (e) {}
    try {
      setTimeout(function () {
        try {
          consentDropped = true;
          if (trackingState() !== "allow") {
            pendingConsent = [];
            if (trackingState() === "deny") queue = [];
          }
        } catch (e) {
          consentDropped = true;
          pendingConsent = [];
        }
      }, CONSENT_MS);
    } catch (e) {}
  }

  function boot() {
    try {
      if (typeof document !== "undefined" && document.prerendering) {
        document.addEventListener("prerenderingchange", boot, { once: true });
        return;
      }
      if (!journeyEnabled()) return;
      getSearchSessionId();
      isSampled();
      bindConsent();
      emitPageView();
      bindMenuObserver();
      bindFilterCommits();
      resumeFilterNavigation();
      try { observeWebVitals(); } catch (eObs) {}
      try { bindJsErrors(); } catch (eJs) {}
      document.addEventListener("click", onClick, true);
      document.addEventListener("submit", onSubmit, true);
      document.addEventListener("change", onChange, true);
      document.addEventListener("focusin", onFocus, true);
      document.addEventListener("toggle", onToggle, true);
      document.addEventListener("keydown", onKeydown, true);
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("pagehide", onPageHide);
      document.addEventListener("visibilitychange", function () {
        try {
          if (document.visibilityState === "hidden") onPageHide();
          else if (document.visibilityState === "visible") pageHideSent = false;
        } catch (e) {}
      });
    } catch (e) {}
  }

  window.sbTrackingAllowed = function () {
    try {
      var state = trackingState();
      if (state === "allow") return true;
      if (state === "deny") return false;
      return null;
    } catch (e) {
      return false;
    }
  };
  window.sbTrackingAllowed.onChange = function (fn) {
    try {
      if (typeof fn === "function") trackingListeners.push(fn);
    } catch (e) {}
  };

  window.SBJourney = {
    track: track,
    addOk: addOk,
    filterStart: filterStart,
    filterNavigate: filterNavigate,
    filterClear: emitFilterClear,
    filterComplete: filterComplete,
    sid: function () {
      try { return getSearchSessionId(); } catch (e) { return ""; }
    },
    flush: function () {
      try { flushQueue(); } catch (e) {}
    }
  };

  boot();
})();
